(() => {
  function initialize(scope) {
    scope.querySelectorAll('.custom-product-carousel-wrapper').forEach((wrapper) => {
      if (wrapper.dataset.aphrosTabsReady) return;
      wrapper.dataset.aphrosTabsReady = 'true';
      const tabs = [...wrapper.querySelectorAll('[role="tab"]')];
      function activate(tab, focus = false) {
        tabs.forEach((item) => {
          const selected = item === tab;
          item.classList.toggle('active', selected);
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
          const panel = document.getElementById(item.getAttribute('aria-controls'));
          if (panel && wrapper.contains(panel)) {
            panel.hidden = !selected;
            panel.classList.toggle('active', selected);
          }
        });
        if (focus) tab.focus();
      }
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', (event) => {
          let target;
          if (event.key === 'ArrowRight') target = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') target = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = tabs.length - 1;
          if (target !== undefined) { event.preventDefault(); activate(tabs[target], true); }
        });
      });
      function scroll(direction) {
        const track = wrapper.querySelector('.custom-carousel-track-wrapper.active .custom-carousel-track');
        if (!track) return;
        const card = track.querySelector('aphros-product-card');
        const distance = (card?.getBoundingClientRect().width || 300) + (parseFloat(getComputedStyle(track).gap) || 20);
        track.scrollBy({ left: direction * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
      wrapper.querySelector('[data-carousel-prev]')?.addEventListener('click', () => scroll(-1));
      wrapper.querySelector('[data-carousel-next]')?.addEventListener('click', () => scroll(1));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
